import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "../../../components/b2b/SideBar";
import VehiclePriceCard from "../../../components/b2c/VehiclePriceCard";
import Header from "../../../components/landingPage/Header";
import LoadingSkeleton from "../../../components/loading/LoadingSkeleton";
import searchingImage from "../../../assets/images/searching.svg";
import SearchResultHeading from "../../../components/b2c/SearchResultHeading";
import { ArrowCircleLeftIcon } from "@heroicons/react/solid";
import { Link, useNavigate } from "react-router-dom";
import momenttz from "moment-timezone";
import {
  getVehicle,
  getVehicles,
} from "../../../redux/app/vehicle/vehicle-slice";
import axios from "axios";
import {
  setConvertedPrice,
  setCurrencyPrice,
  setSearchResultScreen,
  setisSearchingprice,
} from "../../../redux/app/booking/booking-slice";
import moment from "moment";

let vehicleCurrency = {};

const SearchResultB2b = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, user } = useSelector((state) => state.auth);
  const { vehicles, err } = useSelector((state) => state.vehicle);
  const {
    booking,
    distance,
    timezone,
    selectdCurrency,
    convertedPrice,
    checkSourceRegion,
    checkDestinationRegion,
    bookingDuration,
    searchResultScreen,
    isSearchingPrice,
    currencyprice,
    dateChange,
    bookingInitiateLoading,
    dateTimeIST,
  } = useSelector((state) => state.booking);
  const { sourceInputFromApi, destinationInputFromApi } = useSelector(
    (state) => state.map
  );

  // if page relodes then redirect to newbooking page

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      // window.location.pathname = "/newbooking";
    };
  }, []);

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
    localStorage.setItem("relodePage", "true");
  };

  useEffect(() => {
    if (localStorage.getItem("relodePage")) {
      localStorage.removeItem("relodePage");
      navigate("/newbooking");
    }
  }, [navigate]);

  // after reload page then navigate to newbooking page

  const handleBooking = async (vehicle) => {
    let travelTimeStampObj = new Date(
      booking.travelDate + " " + booking.travelTime.split(" ")[1]
    );

    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/places/placeTimezone?lat=${booking?.source?.lat}&lng=${booking?.source?.lng}`
    );

    let travelDate = moment(booking.travelDate).format("YYYY-MM-DD");
    console.log(booking.travelDate, "booking.travelDate<-");
    console.log(travelDate, "travelDate<-");

    let travelTime = booking.travelTime.split(" ")[1];

    const dateTime = momenttz.tz(
      `${travelDate} ${travelTime}`,
      response?.data?.timezone
    );

    const formattedTimestamp = dateTime.format();

    console.log(formattedTimestamp, "formattedTimestamp");

    const payload = {
      source: booking.source,
      destination: booking.destination,
      travelDate: travelDate,
      travelTime: booking.travelTime.split(" ")[1],
      travelTimeStamp: formattedTimestamp,
      passenger: booking.passenger,
      bookingType: booking.bookingType,
      travelDistance: distance,
      priceDetails: {
        amount: currencyprice[vehicle?.vehicleName][selectdCurrency],
        currency: selectdCurrency,
      },
      bookingPriceInUsd: vehicle?.price,
      duration: bookingDuration,
      timeZone: timezone,
      vehicle: {
        vehicleName: vehicle?.vehicleName,
      },
      userName: user?.userName,
      user: user?._id,
      indianTravelDate: moment(dateTimeIST?.converted_time).format(),
      indianTravelTime: moment(dateTimeIST?.converted_time).format("HH:mm"),
    };

    dispatch({
      type: "BOOKING_INITIATE_WITH_VEHICLE",
      payload: {
        payload,
        navigate,
        b2b: true,
      },
    });
    dispatch(
      getVehicle({
        vehicle,
      })
    );
  };

  useEffect(() => {
    if (vehicles === undefined) {
      if (checkDestinationRegion && checkSourceRegion && dateChange) {
        dispatch({
          type: "SEARCH_INITIATE",
        });
      }
    }
  }, [
    vehicles,
    checkDestinationRegion,
    checkSourceRegion,
    dateChange,
    dispatch,
  ]);

  useEffect(() => {
    if (isSearchingPrice) {
      dispatch({
        type: "GET_VEHICLE_UNIT_PRICE",
        payload: {
          currency: selectdCurrency,
          vehicleWithPricevalue: JSON.stringify(currencyprice),
        },
      });
      dispatch(
        setisSearchingprice({
          isSearchingPrice: false,
        })
      );
    }
  }, [isSearchingPrice]);

  useEffect(() => {
    if (localStorage.getItem("newbookingreload")) {
      localStorage.removeItem("newbookingreload");
    }
  }, []);

  return (
    <div className="h-screen w-screen fixed">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen">
          <div className="md:space-x-2 lg:space-x-5 mx-3 md:mx-5">
            <div className="w-min">
              <Link to="/newbooking">
                <ArrowCircleLeftIcon className="w-8 text-gray-600 mt-3" />
              </Link>
            </div>
            <div className="">
              <SearchResultHeading
                b2b={true}
                searchCompleted={true}
                chVehicleCurrent={true}
                showBookingDetail={true}
              />
            </div>
          </div>
          <div className="h-[70vh] overflow-y-auto scrollbar">
            <div className="lg:inline lg:overflow-y-auto pb-16">
              {vehicles === undefined && err === undefined && (
                <div className="space-y-4 my-2">
                  <LoadingSkeleton />
                  <LoadingSkeleton />
                  <LoadingSkeleton />
                </div>
              )}
              {vehicles === undefined && err !== undefined && (
                <>
                  <div className="my-12 mx-auto  text-center text-primary text-2xl font-semibold">
                    <div className="flex space-x-4 items-center justify-center">
                      <div>{err}</div>
                      <Link to="/newbooking">
                        <div
                          onClick={() => {
                            // setopenDrawer(true);
                          }}
                          className="bg-primary hover:bg-red-700 cursor-pointer hover:shadow-md text-center text-lg text-white px-3 py-2 rounded-sm "
                        >
                          Search again
                        </div>
                      </Link>
                    </div>

                    <img
                      src={searchingImage}
                      alt=""
                      className="w-80 block mx-auto my-9"
                    />
                  </div>
                </>
              )}

              {vehicles?.length === 0 && (
                <>
                  <div className="my-12 mx-auto  text-center text-primary text-2xl font-semibold">
                    <div className="flex space-x-4 items-center justify-center">
                      <div>No vehicles found</div>
                      <Link to="/newbooking"></Link>
                    </div>
                  </div>
                </>
              )}

              {vehicles !== undefined &&
                vehicles?.map((vehicle) => (
                  <div className="my-12">
                    {vehicle?.passengeCount >=
                      booking?.passenger?.split("")[0] && (
                      <VehiclePriceCard
                        b2b={true}
                        key={vehicle.vehicleId}
                        vehicleName={vehicle.vehicleType}
                        passengers={vehicle.passengeCount}
                        luggages={vehicle.luggageCount}
                        description={vehicle.description}
                        image={vehicle.image}
                        // price={vehicle.price}
                        price={
                          currencyprice &&
                          currencyprice[vehicle?.vehicleName] &&
                          currencyprice[vehicle?.vehicleName][selectdCurrency]
                            ? currencyprice[vehicle?.vehicleName][
                                selectdCurrency
                              ]
                            : "Loading..."
                        }
                        unit={selectdCurrency ? selectdCurrency : vehicle.unit}
                        onClick={() => handleBooking(vehicle)}
                      />
                    )}
                  </div>
                ))}
              {/* <div className="mb-20"></div> */}
              {/* <VehiclePriceCard /> */}
            </div>
            {/* <div className="pb-32"></div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(SearchResultB2b);
